import "../ProductDetail/index.css";
import "../Product/index.css";
import "../CompanyDetail2/index.css";
import "../CompanyDetail/index.css";
import "../ProductDetail/Component/tablecomponents.css";
import ProductComponent from "../../components/ProductComponent";
import Delete from "../../components/Option/Delete";
import { Back2 } from "../../components/Option/Back";
import { useState, useEffect, useCallback } from "react";
import Add from "../../components/Option/Add";
import { getInventoriesDropdown } from "../../apis/Dropdown";
import { createProduct } from "../../apis/Product";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ContainerBody } from "../../App";
import { useLocation } from "react-router-dom";

const AddProduct = () => {
  const [name, setName] = useState("");
  const [input, setInput] = useState("");
  const [inputId, setInputId] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [unit, setUnit] = useState("");
  const [recycled, setRecycled] = useState("");
  const [landfill, setLandfill] = useState("");
  const [burnt, setBurnt] = useState("");
  const apiVariable = [
    "name",
    "category",
    "qty",
    "origin",
    "shipped_by",
    "new_figure",
    "source",
    "physical_unit",
    "id_dropdown_material",
  ];

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const yearData = queryParams.get("year");
  const subgroupId = queryParams.get("subgroupId");
  const business = queryParams.get("business");

  const [components, setComponents] = useState([
    {
      [apiVariable[0]]: "",
      [apiVariable[1]]: "",
      [apiVariable[2]]: "qty",
      [apiVariable[3]]: "",
      [apiVariable[4]]: "",
    },
  ]);

  const [dropdownBy, setDropdownBy] = useState([]);
  const [errorMessage, setErrorMessage] = useState();
  const [idBusiness, setIdBusiness] = useState("");
  const [status, setStatus] = useState(false);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleMove = useCallback(
    () =>
      navigate(`/product/${idBusiness}?business=${business}&year=${yearData}`, {
        replace: true,
      }),
    [navigate, idBusiness, business]
  );

  useEffect(() => {
    if (status == true) handleMove();
  }, [status]);

  const handleSave = () => {
    createProduct({
      name: name,
      input: input,
      qty: quantity,
      unit: unit,
      supply: inputId,
      year: yearData,
      setStatus: setStatus,
      setErrorMessage: setErrorMessage,
      setIdBusiness: setIdBusiness,
      subgroupId: subgroupId,
      business: business,
    });
  };

  useEffect(() => {
    // // console.log(dropdownMaterial)
  }, []);

  useEffect(() => {}, [input, inputId]);

  const [dropdownInventories, setDropdownInventories] = useState();
  useEffect(() => {
    getInventoriesDropdown({ setDropdown: setDropdownInventories });
  }, []);
  return (
    <ContainerBody className="product__body">
      <div
        className="productdetail__wrapper2"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          height: "0",
        }}
      >
        <Back2
          header={"Back to Product Page"}
          style={{ marginRight: "auto", position: "relative", left: "-7%" }}
          to={"/product"}
        />
      </div>
      <div className="productdetail">
        <div className="productdetail__info" style={{ flexDirection: "row" }}>
          <ProductComponent name={name} />
          <div className="productdetail__info__info">
            <div className="productdetail__info__title">
              <h4 style={{ fontStyle: "italic" }}>{t("PRODUCT_INFO_1")}</h4>
            </div>
            <div
              style={{ flexDirection: "column" }}
              className="productdetail__info__bubble mt-4 d-flex justify-content-between"
            >
              {/* <h4 style={{fontStyle:"italic",fontSize:"15px",fontWeight:"300",marginBottom:"10px"}}>If you know how your products or product waste materials are disposed of once users have finished with them, please indicate here.</h4> */}
              <div className="modaladdlocation__question flex-column w-100 mb-2">
                <div className="d-flex justify-content-start w-100 mb-2">
                  <h3>{t("NAME")}*:</h3>
                  <input
                    className="custom__input"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                {errorMessage ? (
                  <h4 className="text-danger">{errorMessage.name}</h4>
                ) : null}
              </div>
              {/* <div className="modaladdlocation__question flex-column ">
                                <div className="d-flex justify-content-start w-100 mb-2">
                                <h3>Input*:</h3>
                                <EditableResultDropdown
                                    result={input}
                                    edit={true}
                                    changeTo={input}
                                    setValue={setInput}
                                    setValue2={setInputId}
                                    setValue3={setUnit}
                                    setBusinessSize={setInput}
                                    dropdown={dropdownInventories}
                                    extraproperty={"id"}
                                    thirdproperty={"unit"}
                                    autosave={true}
                                    styleNo={4}
                                    withBackground={true}
                                    />
                                </div>
                                {errorMessage?<h4 className="text-danger">{errorMessage.name}</h4>:null}
                            </div>
                            <div className="modaladdlocation__question flex-column">
                                <div className="d-flex justify-content-start w-100 mb-2">
                                <h3>Quantity*:</h3>
                                <input className="custom__input" type="number" value={quantity} onChange={(e) => setQuantity(e.target.value)}/>
                                </div>
                                {errorMessage?<h4 className="text-danger">{errorMessage.name}</h4>:null}
                            </div>
                            <div className="modaladdlocation__question flex-column">
                                <div className="d-flex justify-content-start w-100 mb-2">
                                <h3>Unit*:</h3>
                                <h4>{unit}</h4>
                                </div>
                                {errorMessage?<h4 className="text-danger">{errorMessage.name}</h4>:null}
                            </div> */}
            </div>
          </div>
        </div>
        <div className="productdetail__info" style={{ marginTop: "30px" }}>
          {/* <div className="companydetail__title__container">
                        <img src={componenticon} alt="" />
                        <div className="companydetail__info__title companydetail__title__style2 ">
                            <h5>Components</h5>
                            <h6><i>If you know how your products or product waste materials are disposed of once users have finished with them, please indicate here.</i></h6>
                            </div>
                    </div> */}
          {/* <div className="productdetail__info__bubble" style={{backgroundImage:"none"}}>
                        <ComponentHeader/>
                        <AddComponents
                        addProduct={true}
                        addProductComponents={components}
                        setAddProductComponents={setComponents}
                        components={components}
                        setComponents={setComponents}
                        dropdownMaterial={dropdownMaterial}
                        setDropdownMaterial={setDropdownMaterial}
                        dropdownBy={dropdownBy}
                        errorMessageInherit={errorMessage}
                        />
                    </div> */}
        </div>

        <div className="productdetail__info" style={{ marginTop: "30px" }}>
          {/* <div className="companydetail__title__container">
                        <img src={endoflife} alt="" />
                        <div className="companydetail__info__title companydetail__title__style2">
                            <h5>End of life</h5>
                            <h6><i>If you know how your products or product waste materials are disposed of once users have finished with them, please indicate here.</i></h6>
                        </div>
                    </div>
                    <div className="companydetail__title__container title__special">
                        <img src={governance} alt=""/>
                        <div className="companydetail__info__title companydetail__title__style2">
                            <h5>Equipment</h5>
                            <h6><i>Here is where you list the equipment used in making this product. Try to estimate the % of the total usage time of each piece of equipment that is devoted to making this product.</i></h6>
                        </div>
                    </div>
                    <div className="companydetail__title__container title__special">
                        <img src={homeicon} alt=""/>
                        <div className="companydetail__info__title companydetail__title__style2">
                            <h5>Building</h5>
                            <h6><i>Here is where you list the facilities used to make this product. Try to estimate the % of the total floor space of this building used to make this product.</i></h6>
                        </div>
                    </div> */}
        </div>
      </div>
      <div className="companydetail__wrapper">
        <div className="companydetail__option">
          <Add header={"Save Product"} style={"product"} click={handleSave} />
          <Delete header={"Delete Product"} style={"product"} />
        </div>
      </div>
    </ContainerBody>
  );
};

export default AddProduct;
